window.RA_DEALER_FABRICS = {
  DAA: { twoPiece: 575, threePiece: 665, sportJacket: 425, trousers: 250, vest: 225 },
  DAE: { twoPiece: 625, threePiece: 750, sportJacket: 450, trousers: 275, vest: 225 },
  DAH: { twoPiece: 575, threePiece: 665, sportJacket: 525, trousers: 275, vest: 225 },
  DAL: { twoPiece: 575, threePiece: 665, sportJacket: 525, trousers: 275, vest: 225 },
  DAM: { twoPiece: 575, threePiece: 665, sportJacket: 525, trousers: 275, vest: 215 },
  DAN: { twoPiece: 550, threePiece: 650, sportJacket: 495, trousers: 275, vest: 225 },
  DAP: { twoPiece: 550, threePiece: 650, sportJacket: 595, trousers: 275, vest: 226 },
  DAQ: { twoPiece: 575, threePiece: 665, sportJacket: 525, trousers: 275, vest: 225 },
  DAR: { twoPiece: 625, threePiece: 625, sportJacket: 550, trousers: 275, vest: 225 },
  DAT: { twoPiece: 575, threePiece: 665, sportJacket: 525, trousers: 275, vest: 225 },
  DAU: { twoPiece: 975, threePiece: 1150, sportJacket: 625, trousers: 550, vest: 425 },
  DAV: { twoPiece: 525, threePiece: 625, sportJacket: 425, trousers: 275, vest: 225 },
  DAW: { twoPiece: 925, threePiece: 1150, sportJacket: 625, trousers: 550, vest: 425 },
  DAX: { twoPiece: 675, threePiece: 825, sportJacket: 525, trousers: 325, vest: 295 },
  DAY: { twoPiece: 625, threePiece: 775, sportJacket: 525, trousers: 325, vest: 295 },

  DBB: { twoPiece: 625, threePiece: 775, sportJacket: 525, trousers: 325, vest: 295 },
  DBH: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBI: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBK: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBL: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 225, vest: 275 },
  DBM: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBN: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBP: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBQ: { twoPiece: 475, threePiece: 665, sportJacket: 325, trousers: 275, vest: 225 },
  DBR: { twoPiece: 525, threePiece: 625, sportJacket: 425, trousers: 275, vest: 225 },
  DBS: { twoPiece: 575, threePiece: 665, sportJacket: 450, trousers: 275, vest: 225 },
  DBT: { twoPiece: 575, threePiece: 665, sportJacket: 426, trousers: 275, vest: 225 },
  DBU: { twoPiece: 575, threePiece: 665, sportJacket: 425, trousers: 285, vest: 225 },
  DBV: { twoPiece: 475, threePiece: 625, sportJacket: 325, trousers: 275, vest: 225 },
  DBX: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 250, vest: 195 },

  DDD: { twoPiece: 575, threePiece: 665, sportJacket: 525, trousers: 275, vest: 225 },
  DEB: { twoPiece: 625, threePiece: 725, sportJacket: 475, trousers: 275, vest: 225 },
  DEE: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 275, vest: 225 },
  DFF: { twoPiece: 525, threePiece: 625, sportJacket: 375, trousers: 275, vest: 225 },
  DGG: { twoPiece: 625, threePiece: 775, sportJacket: 450, trousers: 275, vest: 225 },
  DHH: { twoPiece: 775, threePiece: 925, sportJacket: 550, trousers: 425, vest: 375 },
  DII: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 275, vest: 225 },
  DJJ: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DKG: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DKK: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DKP: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DLL: { twoPiece: 525, threePiece: 650, sportJacket: 375, trousers: 285, vest: 225 },
  DNN: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DPP: { twoPiece: 475, threePiece: 565, sportJacket: 326, trousers: 225, vest: 195 },
  DQQ: { twoPiece: 525, threePiece: 650, sportJacket: 375, trousers: 250, vest: 195 },
  DRR: { twoPiece: 675, threePiece: 825, sportJacket: 450, trousers: 325, vest: 225 },
  DUU: { twoPiece: 675, threePiece: 825, sportJacket: 450, trousers: 325, vest: 225 },
  DVV: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DWW: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DXN: { twoPiece: 525, threePiece: 650, sportJacket: 375, trousers: 250, vest: 195 },
  DXX: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 },
  DYY: { twoPiece: 575, threePiece: 825, sportJacket: 425, trousers: 350, vest: 275 },
  DZZ: { twoPiece: 475, threePiece: 650, sportJacket: 325, trousers: 250, vest: 195 },

  TGF: { twoPiece: 475, threePiece: 565, sportJacket: 325, trousers: 225, vest: 195 }
};

window.RA_TROUSERS_ONLY_CODES = new Set([
  "DKK0143",
  "DJJ0088",
  "DJJ0129",
  "DJJ0127",
  "DFF0204",
  "DFF0210",
  "DFF0212",
  "DBV2659",
  "DBV2655",
  "DBV2657",
  "DBV2248",
  "DBV2523",
  "DBV2514",
  "DBV2513",
  "DBV2512",
  "DBV2726",
  "DBV2510",
  "DBV2509",
  "DBV2504",
  "DBV2502",
  "DBV2109",
  "DBV2108",
  "DBV2107",
  "DBV2628",
  "DBV2707",
  "DBV2627",
  "DBV2706",
  "DBV2636",
  "DBV2700",
  "DBU1586",
  "DBV6222"
]);